import moduleService from '../../services/module.service';
import taskService from '../../services/task.service';

export default {
    namespaced: true,
    state: {
        selectedModule: {},
        moduleList: [],
        taskList: [],
    },
    getters: {
        getSelectedModule: (state) => state.selectedModule,
        getModuleList: (state) => state.moduleList,
        getTaskList: (state) => state.taskList,
        getModuleListOptions: (state) => {
            return state.moduleList.map((module) => {
                return {
                    value: module.id,
                    label: module.name,
                };
            });
        },
    },
    mutations: {
        setModuleList(state, module) {
            state.moduleList = module;
        },
        setTaskList(state, task) {
            state.taskList = task;
        },
        setSelectedModule(state, module) {
            state.selectedModule = module;
        },
    },
    actions: {
        SET_SELECTED_MODULE({ commit }, module) {
            commit('setSelectedModule', module);
        },
        SET_MODULE_LIST({ commit }, module) {
            commit('setModuleList', module);
        },
        SET_TASK_LIST({ commit }, module) {
            commit('setTaskList', module);
        },
        GET_ALL_MODULE({ commit }, { name }) {
            moduleService.getModuleList(
                {
                    params: {
                        name,
                    },
                },
                {
                    success: ({ data }) => {
                        commit('setModuleList', data.data);
                    },
                    error: (error) => {
                        console.log(error);
                        console.clear();
                    },
                }
            );
        },
        GET_MODULE_BY_ID({ state, commit }) {
            moduleService.getModuleById(state.selectedModule.id, {
                success: ({ data }) => {
                    commit('setSelectedModule', data.data);
                },
                error: (error) => {
                    console.log(error);
                    console.clear();
                },
            });
        },
        GET_ALL_TASK_BY_MODULE_ID({ state, commit }, value = state.selectedModule.id) {
            taskService.getTaskByModuleById(value, {
                success: ({ data }) => {
                    commit('setTaskList', data.data);
                },
                error: (error) => {
                    console.log(error);
                    console.clear();
                },
            });
        },

        GET_ALL_MODULE_BY_CATEGORY_ID({ commit }, id) {
            moduleService.getModuleByCategoryId(id, {
                success: ({ data }) => {
                    commit('setModuleList', data.data);
                },
                error: (error) => {
                    console.log(error);
                    console.clear();
                },
            });
        },

        CREATE_TASK({ state, dispatch }, { payload, successCallback, errorCallback }) {
            taskService.createTask(
                { ...payload, moduleId: state.selectedModule.id, categoryId: state.selectedModule.category.id },
                {
                    success: (res) => {
                        dispatch('GET_ALL_TASK_BY_MODULE_ID');
                        successCallback && successCallback(res);
                    },
                    error: (err) => {
                        errorCallback && errorCallback(err);
                    },
                }
            );
        },
        UPDATE_TASK({ state, dispatch }, { payload, successCallback, errorCallback }) {
            taskService.updateTask(
                { ...payload, moduleId: state.selectedModule.id },
                {
                    success: (res) => {
                        dispatch('GET_ALL_TASK_BY_MODULE_ID');
                        successCallback && successCallback(res);
                    },
                    error: (err) => {
                        errorCallback && errorCallback(err);
                    },
                }
            );
        },
        CREATE_NEW_MODULE({ dispatch }, { payload, successCallback, errorCallback }) {
            moduleService.createModule(payload, {
                success: (res) => {
                    dispatch('GET_ALL_MODULE', { name: '' });
                    successCallback && successCallback(res);
                },
                error: (err) => {
                    errorCallback && errorCallback(err);
                },
            });
        },
        UPDATE_MODULE({ dispatch }, { payload, successCallback, errorCallback }) {
            moduleService.updateModule(payload, {
                success: (res) => {
                    dispatch('GET_ALL_MODULE', { name: '' });
                    successCallback && successCallback(res);
                },
                error: (err) => {
                    errorCallback && errorCallback(err);
                },
            });
        },
    },
};
